const calculateMaxPagesNumber = (dataLength: number, pageSize: number) => {
  return Math.ceil(dataLength / pageSize);
};

export default calculateMaxPagesNumber;
